var _defs, _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayberet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 481.62 237.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7f7d9f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.46,265.52l4,39.48s230.26,9.13,405.9-57.68L544,200.24Z",
    transform: "translate(-101.9 -67.48)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 342.71,
    cy: 188.5,
    rx: 243.5,
    ry: 82.5,
    transform: "translate(-127.34 -11.07) rotate(-9.08)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306,115.5s-7-47,18-48-6.94,48-6.94,48Z",
    transform: "translate(-101.9 -67.48)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayberet);
export default __webpack_public_path__ + "static/media/gray beret.fceddc28.svg";
export { ForwardRef as ReactComponent };